import { getMasterLegalEntities } from "actions/Utilities/MasterLegalEntity";
import { useQuery } from "react-query";

const useGetMasterLegalEntities = () => {
  return useQuery("GetMasterLegalEntity", () => getMasterLegalEntities(), {
    refetchOnWindowFocus: false,
    // staleTime: Infinity,
  });
};

export default useGetMasterLegalEntities;
